import './grnDetail.css';
import { formatDate } from '../../../util/helper';
import { Table } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { GetJWVendorDetails } from '../jw-grn/helper';

const DamageDetail = ({ isPrint, data }) => {
  // const [factory, setFactory] = useState({});
  const [vendorData, setVendorData] = useState([]);
  // const branchId = grnType === 'JW' ? data.locationId : data.factoryId;
  // useEffect(() => {
  //   if (branchId) {
  //     get('/branches/?id=' + branchId).then((branch) => {
  //       if (branch.data.rows.length) {
  //         setFactory(branch.data.rows[0]);
  //       }
  //     });
  //   }
  // }, [branchId]);

  useEffect(() => {
    if (data.kitchenId) {
      GetJWVendorDetails(data.kitchenId).then((res) => {
        setVendorData(res);
      });
    }
  }, []);
  return (
    <div className={`grn-detail ${isPrint ? 'print-view me-5 ms-5' : ''}`}>
      <div className="text-center">
        <div className="mb-3">
          <h4 className="m-0 mb-2">Kanti Sweets Private Limited</h4>
          {/* <h6 className="m-0" style={{ fontSize: '11px' }}>
            {factory?.name}
            <br />
            {factory?.address}
          </h6> */}
        </div>
        <div>
          <h5 className="mb-2">
            <b>
              <u>DAMAGE DETAILS</u>
            </b>
          </h5>
        </div>
      </div>
      <Table bordered striped responsive className="mt-3">
        <tbody>
          <tr>
            <th>Name</th>
            <td>{data?.Kitchen?.name || data?.VendorMaster?.name || data?.supplierName}</td>
            <th>Address</th>
            <td>{data?.supplierAddress || data?.VendorMaster?.address || vendorData?.address}</td>
            <th>Supplier GST No.</th>
            <td>{data?.supplierGstin || data?.VendorMaster?.gst_num || vendorData?.gst_num}</td>
          </tr>
          <tr>
            <th>GRN No.</th>
            <td>{data?.jwDamageNumber ?? 'NA'}</td>
            <th>GRN Date</th>
            <td>{data?.jwDamageDate ? formatDate(data?.jwDamageDate) : 'NA'}</td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </Table>

      <Table striped bordered className="text-center grn-detail-table">
        <thead>
          <tr>
            <th className="p-0.5">Sl No.</th>
            <th className="p-05">Item Name</th>
            <th className="p-05">HSN Code</th>
            <th className="p-05">Unit</th>
            {!isPrint && <th className="p-05">Description</th>}

            <th className="p-05">Qty Damaged</th>
            {!isPrint && (
              <>
                <th className="trp-5">Rate Per Unit</th>
                <th className="trp-5">CGST</th>
                <th className="trp-5">SGST</th>
                <th className="trp-5">IGST</th>
                <th className="trp-5">Invoice Amount</th>
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {data?.assetsInfo?.map((item, index) => {
            return (
              <tr key={index}>
                <td className="p-05">{index + 1}</td>
                <td className="p-05">{item?.itemName}</td>
                <td className="p-05">{item?.hsnCode}</td>
                <td className="p-05">{item?.unit}</td>
                {!isPrint && <td className="trp-5">{item?.description}</td>}
                <td className="p-05">{item?.quantityDamaged}</td>
                {!isPrint && (
                  <>
                    <td className="trp-5">{item?.rate}</td>
                    <td className="trp-5">{item?.cgst}</td>
                    <td className="trp-5">{item?.sgst}</td>
                    <td className="trp-5">{item?.igst}</td>
                    <td className="trp-5">{item?.invoiceAmount}</td>
                  </>
                )}
              </tr>
            );
          })}
        </tbody>
      </Table>

      {isPrint && (
        <Table style={{ width: '100%', marginTop: '60px' }}>
          <tfoot>
            <tr>
              <td width="33.33%">
                <h6>Prepared by</h6>
              </td>
              <td width="33.33%" align="center">
                <h6>Stores Incharge</h6>
              </td>
              <td width="33.33%" align="right">
                <h6>Authorised Signatory/Manager</h6>
              </td>
            </tr>
          </tfoot>
        </Table>
      )}

      {!isPrint && (
        <div className="total-amount">
          <p>
            <span>Charge Type ({data?.chargeType ?? 'NA'})</span>
            <span>{data?.chargeAmount}</span>
          </p>
          <p style={{ fontWeight: 'bold' }}>
            <span>Total Amount</span>
            <span style={{ marginLeft: '35px' }}>{data?.totalAmount}</span>
          </p>
        </div>
      )}
    </div>
  );
};

export default DamageDetail;
